// /* eslint-disable no-unused-vars */
// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { baseUrl } from "../../config/baseUrl"
// import { toast } from "react-toastify";

// export default function CouponAdd() {
//     const navigate = useNavigate();
//     const [formval, setFormval] = useState({
//         coupon_Code: "",
//         discount: "",
//         start_date: "",
//         end_date: "",
//         status: "true",
//     });

//     let changeHandler = (e) => {
//         setFormval((preVal) => ({ ...preVal, [e.target.name]: e.target.value }));
//     };

//     let handleSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             const response = await fetch(`${baseUrl}/coupon`, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(formval),
//             });
//             if (response.ok) {
//                 const data = await response.json();
//                 toast.success("Coupon Added Successfully");
//                 setFormval({
//                     coupon_Code: "",
//                     discount: "",
//                     start_date: "",
//                     end_date: "",
//                     status: "true",
//                 });
//                 navigate("/coupons");
//             }
//             else {
//                 const errorData = await response.json();
//                 toast.error(errorData.message);
//             }

//         } catch (error) {
//             console.error("Error :", error);
//         }
//     };
//     // let handleSubmit = async (e) => {
//     //     e.preventDefault();

//     //     const { start_date, end_date } = formval;


//     //     if (start_date && end_date && new Date(end_date) <= new Date(start_date)) {
//     //         toast.error("End Date must be after Start Date");
//     //         return;
//     //     }

//     //     try {
//     //         const response = await fetch(`${baseUrl}/coupon`, {
//     //             method: "POST",
//     //             headers: {
//     //                 "Content-Type": "application/json",
//     //             },
//     //             body: JSON.stringify(formval),
//     //         });

//     //         if (response.ok) {
//     //             const data = await response.json();
//     //             toast.success("Coupon Added Successfully");
//     //             setFormval({
//     //                 coupon_Code: "",
//     //                 discount: "",
//     //                 start_date: "",
//     //                 end_date: "",
//     //                 status: "true",
//     //             });
//     //         } else {
//     //             const errorData = await response.json();
//     //             toast.error(errorData.message || "Failed to add coupon");
//     //         }
//     //     } catch (error) {
//     //         console.error("Error:", error);
//     //         toast.error("Something went wrong");
//     //     }
//     // };


//     return (
//         <>
//             <section className="main-sec">
//                 <div className="row align-items-center">
//                     <div className="col-lg-6">
//                         <div className="dashboard-title">
//                             <h4 className="dash-head">
//                                 <i className="fa fa-users me-2" />
//                                 Add Coupon
//                             </h4>
//                         </div>
//                         <div className="custom-bredcump">
//                             <nav aria-label="breadcrumb">
//                                 <ol className="breadcrumb">
//                                     <li className="breadcrumb-item">
//                                         <Link to="/">Dashboard</Link>
//                                     </li>
//                                     <li className="breadcrumb-item active" aria-current="page">
//                                         Add Coupon
//                                     </li>
//                                 </ol>
//                             </nav>
//                         </div>
//                     </div>
//                     <div className="col-lg-6 d-flex justify-content-end">
//                         <Link to="/coupons" className="btn btn-info text-white">
//                             <i className="fa fa-arrow-left me-1"></i>
//                             Back
//                         </Link>
//                     </div>
//                 </div>
//                 <div className="row">
//                     <div className="col-lg-12">
//                         <div className="cards edit-usr">
//                             <form action="" onSubmit={handleSubmit}>
//                                 <div className="row">
//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="coupon_Code" className="form-label">
//                                             Coupon Code<sup className="text-danger">*</sup>
//                                         </label>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             name="coupon_Code"
//                                             id="coupon_Code"
//                                             placeholder="Coupon Code"
//                                             onChange={changeHandler}
//                                             value={formval?.coupon_Code}
//                                         />
//                                     </div>
//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="discount" className="form-label">
//                                             Discount(%)<sup className="text-danger">*</sup>
//                                         </label>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             name="discount"
//                                             id="discount"
//                                             placeholder="Offer(%)"
//                                             onChange={changeHandler}
//                                             value={formval?.discount}
//                                         />
//                                     </div>

//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="start_date" className="form-label">
//                                             Start Date<sup className="text-danger">*</sup>
//                                         </label>
//                                         <input
//                                             type="date"
//                                             className="form-control"
//                                             name="start_date"
//                                             id="start_date"
//                                             placeholder="End Time"
//                                             onChange={changeHandler}
//                                             value={formval?.start_date}
//                                         />
//                                     </div>

//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="end_date" className="form-label">
//                                             End Date<sup className="text-danger">*</sup>
//                                         </label>
//                                         <input
//                                             type="date"
//                                             className="form-control"
//                                             name="end_date"
//                                             id="end_date"
//                                             placeholder="End Time"
//                                             onChange={changeHandler}
//                                             value={formval?.end_date}
//                                             min={formval.start_date || ""}
//                                         />
//                                     </div>

//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="status" className="form-label">
//                                             Status<sup className="text-danger">*</sup>
//                                         </label>
//                                         <select className="form-control">
//                                             <option value={"true"}>Active</option>
//                                             <option value={"false"}>Inactive</option>
//                                         </select>
//                                     </div>


//                                     <div className="col-lg-12 text-center">
//                                         <button
//                                             type="Submit"
//                                             className="btn btn-for-add text-white"
//                                         >
//                                             <i className="fa fa-save me-1"></i>
//                                             Save
//                                         </button>
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// }
"use client"

import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { baseUrl } from "../../config/baseUrl"
import { toast } from "react-toastify"
import axios from "axios"

export default function CouponAdd() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [formval, setFormval] = useState({
        coupon_Code: "",
        discount: "",
        start_date: "",
        end_date: "",
        status: true,
    })

    const changeHandler = (e) => {
        setFormval((preVal) => ({ ...preVal, [e.target.name]: e.target.value }))
    }

    // Validation function
    const validateForm = () => {
        const { coupon_Code, discount, start_date, end_date } = formval

        if (!coupon_Code.trim()) {
            toast.error("Coupon code is required")
            return false
        }

        if (!discount || discount <= 0 || discount > 100) {
            toast.error("Discount must be between 1 and 100")
            return false
        }

        if (!start_date) {
            toast.error("Start date is required")
            return false
        }

        if (!end_date) {
            toast.error("End date is required")
            return false
        }

        if (new Date(end_date) <= new Date(start_date)) {
            toast.error("End date must be after start date")
            return false
        }

        if (new Date(start_date) < new Date().setHours(0, 0, 0, 0)) {
            toast.error("Start date cannot be in the past")
            return false
        }

        return true
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!validateForm()) {
            return
        }

        try {
            setLoading(true)
            const response = await axios.post(`${baseUrl}/api/v1/admin/coupon/coupon-store`, formval, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("token"),
                },
            })

            if (response.status === 200 || response.status === 201) {
                toast.success("Coupon added successfully")
                setFormval({
                    coupon_Code: "",
                    discount: "",
                    start_date: "",
                    end_date: "",
                    status: "true",
                })
                navigate("/coupons")
            }
        } catch (error) {
            console.error("Error:", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error("Failed to add coupon")
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <section className="main-sec">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="dashboard-title">
                            <h4 className="dash-head">
                                <i className="fa fa-ticket me-2" />
                                Add Coupon
                            </h4>
                        </div>
                        <div className="custom-bredcump">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/coupons">Coupons</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Add Coupon
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end">
                        <Link to="/coupons" className="btn btn-info text-white">
                            <i className="fa fa-arrow-left me-1"></i>
                            Back
                        </Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="cards edit-usr">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="coupon_Code" className="form-label">
                                            Coupon Code<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="coupon_Code"
                                            id="coupon_Code"
                                            placeholder="Enter coupon code (e.g., SAVE20)"
                                            onChange={changeHandler}
                                            value={formval?.coupon_Code}
                                            required
                                            style={{ textTransform: "uppercase" }}
                                        />
                                        <small className="text-muted">Use uppercase letters and numbers only</small>
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="discount" className="form-label">
                                            Discount (%)<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="discount"
                                            id="discount"
                                            placeholder="Enter discount percentage"
                                            onChange={changeHandler}
                                            value={formval?.discount}
                                            min="1"
                                            max="100"
                                            required
                                        />
                                        <small className="text-muted">Enter value between 1 and 100</small>
                                    </div>

                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="start_date" className="form-label">
                                            Start Date<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="start_date"
                                            id="start_date"
                                            onChange={changeHandler}
                                            value={formval?.start_date}
                                            min={new Date().toISOString().split("T")[0]}
                                            required
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="end_date" className="form-label">
                                            End Date<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="end_date"
                                            id="end_date"
                                            onChange={changeHandler}
                                            value={formval?.end_date}
                                            min={formval.start_date || new Date().toISOString().split("T")[0]}
                                            required
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="status" className="form-label">
                                            Status<sup className="text-danger">*</sup>
                                        </label>
                                        <select
                                            className="form-control"
                                            name="status"
                                            id="status"
                                            onChange={changeHandler}
                                            value={formval?.status}
                                        >
                                            <option value="true">Active</option>
                                            <option value="false">Inactive</option>
                                        </select>
                                    </div>

                                    <div className="col-lg-12 text-center">
                                        <button type="submit" className="btn btn-for-add text-white" disabled={loading}>
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Saving...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa fa-save me-1"></i>
                                                    Save Coupon
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}   
